import React from "react"
import { Link } from "gatsby"
import { MdFacebook } from "react-icons/md"
import { IoLogoInstagram } from "react-icons/io"
import { SiGooglemybusiness } from "react-icons/si"

import { useSiteMetadata } from "../hooks/useSiteMetadata"

const navigation = {
  social: [
    {
      name: "Facebook",
      href: "https://www.facebook.com/OlyaKoval.NailSalon",
      icon: <MdFacebook className="h-6 w-6" />,
    },
    {
      name: "Instagram",
      href: "https://www.instagram.com/ok_wax_nails/",
      icon: <IoLogoInstagram className="h-6 w-6" />,
    },
    {
      name: "Google Business",
      href: "https://goo.gl/maps/d1d25uAW6pAFa4Dw5",
      icon: <SiGooglemybusiness className="h-6 w-6" />,
    },
  ],
}

export default function FooterComponent() {
  // Only active menu items
  const menuItems = useSiteMetadata().datoCmsCompany.menuItems.filter(
    item => item.isActive,
  )
  return (
    <footer className="bg-slate-900 text-slate-50">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
        <nav
          className="-mx-5 -my-2 flex flex-wrap justify-center"
          aria-label="Footer"
        >
          {menuItems.map(item => (
            <Link
              key={item.id}
              to={item.to}
              className="mx-5 my-2 text-slate-50 hover:text-amber-200"
              activeClassName="border-b border-amber-200"
            >
              {item.title}
            </Link>
          ))}
        </nav>
        <div className="mt-8 flex justify-center space-x-6">
          {navigation.social.map(item => (
            <a
              key={item.name}
              href={item.href}
              className="text-slate-400 hover:text-amber-200"
              rel="noopener noreferrer"
              target="_blank"
            >
              <span className="sr-only">{item.name}</span>
              {item.icon}
            </a>
          ))}
        </div>
        <p className="mt-8 text-center text-slate-50">
          &copy; {new Date().getFullYear()} Olya Koval Nail Salon. All rights
          reserved.
        </p>
      </div>
    </footer>
  )
}
